module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-07.c557e047.png";